/**
 * Global application configuration.
 * Should store run-time options, paths, flags and so on.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

// public
module.exports = {
    pathToImageAtUsb: '',
    selectedImage: 0
};
